import { FormControlLabel, styled, Switch, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";

export default function MainSwitch({
    label,
    value,
    onChange,
    size = "small",
}) {
    const { mode } = useColorScheme();
    const currentMode = mode || "system";

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 32,
        height: 18,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(14px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: Constants.Colors[currentMode].accent,
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: Constants.Colors[currentMode].background,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 14,
            height: 14,
        },
        '& .MuiSwitch-track': {
            borderRadius: 18 / 2,
            backgroundColor: Constants.Colors[currentMode].mutedForeground,
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));
    return (
        label ? <FormControlLabel
            control={<IOSSwitch
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
                size={size}
            />}
            label={<Typography
                sx={{
                    color: Constants.Colors[currentMode].mutedForeground,
                    fontSize: Constants.Styles.fontSize.sm,
                    lineHeight: Constants.Styles.lineHeight.sm,
                    ml: 1,
                }}
            >{label}</Typography>}
        /> : <IOSSwitch
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            size={size}
            sx={{

            }}
        />
    );
}